/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "./views/Dashboard.js";
import Form from './views/FormAdminPlaces.js';
import FormCrearAdmin from './views/FormCrearAdmin.js';
//import FormLoadData from './views/FormLoadData.js';
import FormUpdateData from './views/FormUpdateData.js';
//import FormGooglePlaces from './views/FormGooglePlaces.js';
import Traducctions from './views/FormCreateExcel.js';
//import FormTags from './views/FormTags.js';
//import TableGoogleActivities from "./views/TableGoogleActivities.js";
import TableCalendar from "./views/TableCalendar.js";
import TableUsers from "./views/TableUsers.js";
import TableActivities from "./views/TableActivities.js";
import TableActivitiesHidden from "./views/TableActivitiesHidden.js";
import TableActivitiesIncomplete from "./views/TableActivitiesIncomplete.js";
import TableAdmins from "./views/TableAdmin";
import FormCities from './views/FormCities.js';
import TableCities from "./views/TableCities.js";
import FormCrearAgenciaHotel from "./views/FormCrearAgenciaHotel.js";
import createInfluencer from "./views/influencers/createInfluencer.js";
import UserProfile from "./views/UserProfile.js";
import VentasCalendarios from "./views/VentasCalendarios.js";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "tim-icons icon-chart-pie-36",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/Usuarios",
    name: "Usuarios",
    icon: "tim-icons icon-bullet-list-67",
    component: TableUsers,
    layout: "/admin",
  },
  {
    path: "/BussinessAgency",
    name: "Crear Bussiness Agency",
    icon: "tim-icons icon-bullet-list-67",
    component: FormCrearAgenciaHotel,
    layout: "/admin",
  },
  {
    path: "/influencer/create",
    name: "Crear influencer",
    icon: "tim-icons icon-bullet-list-67",
    component: createInfluencer,
    layout: "/admin",
  },
  {
    path: "/calendarios",
    name: "Calendarios",
    icon: "tim-icons icon-bullet-list-67",
    component: TableCalendar,
    layout: "/admin",
  },
  {
    path: "/Actividades",
    name: "Ver actividades",
    icon: "tim-icons icon-bullet-list-67",
    component: TableActivities,
    layout: "/admin",
  },
  {
    path: "/ActividadesOcultas",
    name: "Ver Ocultas",
    icon: "tim-icons icon-bullet-list-67",
    component: TableActivitiesHidden,
    layout: "/admin",
  },
  {
    path: "/ActividadesIncompletas",
    name: "Ver incompletas",
    icon: "tim-icons icon-bullet-list-67",
    component: TableActivitiesIncomplete,
    layout: "/admin",
  },
  {
    path: "/InsertActivities",
    name: "Crear Actividades",
    icon: "tim-icons icon-pencil ",
    component: Form,
    layout: "/admin",
  },/*
  {
    path: "/InsertActivitiesExcel",
    name: "Cargar Actividades",
    icon: "tim-icons icon-pencil ",
    component: FormLoadData,
    layout: "/admin",
  },*/
  {
    path: "/UpdateActivitiesExcel",
    name: "Actualizar Actividades",
    icon: "tim-icons icon-pencil ",
    component: FormUpdateData,
    layout: "/admin",
  },/*
  {
    path: "/Agencias",
    name: "Crear Agencias",
    icon: "tim-icons icon-align-center",
    component: FormCrearAgencia,
    layout: "/admin",
  },*/
  {
    path: "/Ciudades",
    name: "Ver ciudades",
    icon: "tim-icons icon-bullet-list-67",
    component: TableCities,
    layout: "/admin",
  },
  {
    path: "/InsertCities",
    name: "Crear ciudades",
    icon: "tim-icons icon-pencil ",
    component: FormCities,
    layout: "/admin",
  },/*
  {
    path: "/GooglePlaces",
    name: "Ver GooglePlaces",
    icon: "tim-icons icon-bullet-list-67 ",
    component: TableGoogleActivities,
    layout: "/admin",
  },
  {
    path: "/RequestGooglePlaces",
    name: "Actualizar GooglePlaces",
    icon: "tim-icons icon-pencil ",
    component: FormGooglePlaces,
    layout: "/admin",
  },
  {
    path: "/map",
    name: "Map",
    icon: "tim-icons icon-pin",
    component: Map,
    layout: "/admin",
  },/
  {
    path: "/mapGoogle",
    name: "MapGoogle",
    icon: "tim-icons icon-pin",
    component: MapGoogle,
    layout: "/admin",
  },*/
  {
    path: "/VerAdmins",
    name: "Ver Admins",
    icon: "tim-icons icon-bullet-list-67",
    component: TableAdmins,
    layout: "/admin",
  },
  {
    path: "/CreateAdmin",
    name: "Crear Admin",
    icon: "tim-icons icon-pencil",
    component: FormCrearAdmin,
    layout: "/admin",
  },/*
  {
    path: "/CreateRedactor",
    name: "Crear redactor",
    icon: "tim-icons icon-pencil",
    component: FormCrearRedactorBlog,
    layout: "/admin",
  },/
  {
    path: "/Tags",
    name: "Crear y ver Tags",
    icon: "tim-icons icon-pencil",
    component: FormTags,
    layout: "/admin",
  },*/

  {
    path: "/ActualizarUsuario/:id",
    name: "Actualizar Usuario",
    icon: "tim-icons icon-pencil",
    component: UserProfile,
    layout: "/admin",
  },
  {
    path: "/Traducctions",
    name: "traducciones",
    icon: "tim-icons icon-pencil",
    component: Traducctions,
    layout: "/admin",
  },
  {
    path: "/vendidos",
    name: "Calendarios Vendidos",
    icon: "tim-icons icon-basket-simple",
    component: VentasCalendarios,
    layout: "/admin"
  },
];
export default routes;
